import { Star } from "lucide-react";

export function StarRating({
  value,
  onChange,
  size = 20,
  readOnly = false,
}: {
  value: number;
  onChange?: (n: number) => void;
  size?: number;
  readOnly?: boolean;
}) {
  return (
    <div className="flex gap-0.5" role={readOnly ? "img" : "group"} aria-label={readOnly ? `${value} out of 5 stars` : "Rate 1 to 5 stars"}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={() => onChange?.(n)}
          className={readOnly ? "pointer-events-none" : "transition-transform active:scale-95"}
        >
          <Star
            size={size}
            className={n <= value ? "fill-amber-400 text-amber-400" : "text-white/25"}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
}
